// Initial state
const state = {
  visible: true,
  items: [
    { icon: 'dashboard', text: 'Dashboard', key: 'dashboard', routerName: 'Main', role: 'ADMINISTRATOR', visible: true },
    { icon: 'show_chart', text: 'Sales overview', key: 'sales', routerName: 'Sales', role: 'ADMINISTRATOR', visible: true },
    { icon: 'bar_chart', text: 'Supplier overview', key: 'supplier', routerName: 'Supplier', role: 'ADMINISTRATOR', visible: true },
    { icon: 'stacked_bar_chart', text: 'Statistics', key: 'statistics', routerName: 'Statistics', role: 'ADMINISTRATOR', visible: false },
    { icon: 'shopping_cart', text: 'Orders', key: 'orders', routerName: 'Orders', role: 'ADMINISTRATOR', visible: true },
    { icon: 'fa-tag', text: 'Labelling', key: 'label_report', routerName: 'LabelReport', role: 'ADMINISTRATOR', visible: true },
    { icon: 'a-boxes', text: 'Shipments', key: 'shipments', routerName: 'Shipments', role: 'ADMINISTRATOR', visible: true },
    { icon: 'fa-truck-loading', text: 'Intern transport', key: 'transports', routerName: 'Transports', role: 'ADMINISTRATOR', visible: true },
    { icon: 'a-pallet', text: 'Pallets', key: 'pallets', routerName: 'Pallets', role: 'ADMINISTRATOR', visible: true },
    { icon: 'a-trees', text: 'Categories', key: 'categories', routerName: 'Categories', role: 'ADMINISTRATOR', visible: true },
    { icon: 'a-store', text: 'Customers', key: 'customers', routerName: 'Customers', role: 'ADMINISTRATOR', visible: true },
    { icon: 'fa-tractor', text: 'Contractors', key: 'contractors', routerName: 'Contractors', role: 'ADMINISTRATOR', visible: true },
    { icon: 'a-forklift', text: 'Loaders', key: 'loaders', routerName: 'Loaders', role: 'ADMINISTRATOR', visible: true },
    { icon: 'a-factory', text: 'Suppliers', key: 'suppliers', routerName: 'Suppliers', role: 'ADMINISTRATOR', visible: true },
    { icon: 'local_shipping', text: 'Carriers', key: 'carriers', routerName: 'Carriers', role: 'ADMINISTRATOR', visible: true },
    { icon: 'fa-id-badge', text: 'Employees', key: 'employees', routerName: 'Employees', role: 'ADMINISTRATOR', visible: true },
    { icon: 'fa-user-friends', text: 'Users', key: 'users', routerName: 'Users', role: 'ADMINISTRATOR', visible: true },
    { icon: 'history', text: 'Log', key: 'log', routerName: 'Log', role: 'ADMINISTRATOR', visible: true },
    { icon: 'settings', text: 'Configuration', key: 'configuration', routerName: 'Configuration', role: 'ADMINISTRATOR', visible: true }
  ]
}

// Mutations
const mutations = {
  toggleVisible (state, userContext) {
    state.visible = !state.visible
  }
}

// Actions
const actions = {
  toggle ({ commit, state }) {
    commit('toggleVisible')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar.js